
const FilterButtons = ({ categories, selected, onSelect }) => {
    return (
        <div className="flex gap-3 mb-6 overflow-x-auto whitespace-nowrap scrollbar-hide">

            {categories.map((cat) => (

                <button
                    key={cat}
                    onClick={() => onSelect(cat)}
                    className={`shrink-0 border-[1.13px] border-gray-300 px-4 py-2 rounded-xs focus:outline-none text-sm transition

                    ${selected === cat
                            ? "bg-[#0475B3] text-white border-[#0475B3]"
                            : "bg-[rgba(249,250,251,1)] text-gray-700 hover:bg-gray-100"
                        }
                    `}
                >
                    {cat}
                </button>

            ))}

        </div>
    );
};

export default FilterButtons;